<template>
  <div class="wl-comments-container">
    <div class="wl-title">{{$t('PAGE_MATTERLOG_COMMENTS')}}</div>

    <m-tree ref="tree"
            :data="this.data.commentList"
            :onAdd="onAddComment"/>
    <div class="wl-title">{{$t('PAGE_MATTERLOG_REPLY')}}</div>

    <add-comment :loading="loading"
                 :pid="data.id"
                 :onAdd="onAddComment"/>

  </div>
</template>
<script>
    import MTree from './tree';
    import AddComment from './add-comment';
    import {mapGetters} from 'vuex';
    import API from '@/api';

    export default {
        data() {
            return {
                commentList: [],
                loading: false
            };
        },
        methods: {
            async onAddComment(content, pid, attachmentList) {
                this.loading = !this.loading
                const params = {
                    id: pid,
                    comments: content,
                    attachmentList: attachmentList,
                    siteId: this.getSite.siteId
                }
                API.matterLogs.addComments(params).then(res => {
                    if (res.code == '1') {
                        this.$message.success(this.$t('msg_success'));
                        this.loading = !this.loading
                        this.onComments(attachmentList)
                    } else {
                        this.$message.error(this.$t(res.code));
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.$message.error(this.$t('SYS_USER_003'))
                })
                .finally(() => {
                    this.loading = false
                })
            }
        },
        computed: {
            ...mapGetters('common', {
                user: 'getUser',
                getSite: 'getSite'
            })
        },
        components: {
            MTree,
            AddComment
        },
        props: {
            data: Object,
            onComments: Function
        }
    };
</script>
<style scoped>
  .wl-comments-container {
    height: 360px;
    margin-top: 12px;
  }

  .wl-title {
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    color: #696969;
    text-align: left;
    line-height: 40px;
  }
</style>
